<div class="row">
    <form [formGroup]="resourcesForm">
        <div class="follow-up">
            @if (showLabel) {
            <div class="follow-up-title">
                Follow-Up
            </div>
            }
            <div class="priority-follow-up">
                <mat-form-field class="app-form-field app-high-form-field app-form-field-with-border priority">
                    <mat-icon [ngClass]="priority?.class" class="prefix">{{priority?.icon}}</mat-icon>
                    <div class="prefix-title">{{priority?.value}}</div>
                    <mat-select panelClass="recruiter-panel-class" disableOptionCentering="true" class="priority-select"
                        formControlName="priorityList" (selectionChange)="selectionPriorityChange($event.value)">
                        @for (priority of priorityList; track priority) {
                        <mat-option class="select-option" [value]="priority">
                            <mat-icon [ngClass]="priority?.class" class="inner-prefix">{{priority?.icon}}</mat-icon>
                            {{ priority?.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="calendar-wrap">
                <mat-form-field [floatLabel]="'never'"
                    class="app-form-field app-high-form-field app-full-width-form-field app-form-field-with-border whitelisted calendar">
                    <input matInput placeholder="MM/DD/YYYY" [mask]="shortDateMask" [leadZeroDateTime]="true"
                        [dropSpecialCharacters]="false" formControlName="date" />
                    <mat-icon (click)="toggleCalendar($event)" class="suffix whitelisted">event</mat-icon>
                </mat-form-field>
            </div>
            <div class="time-wrap">
                <mat-form-field
                    class="app-form-field app-high-form-field app-full-width-form-field app-form-field-with-border timer">
                    <mat-select panelClass="recruiter-panel-class" disableOptionCentering="true" class="time"
                        formControlName="time">
                        @for (hour of hours; track hour) {
                        <mat-option [value]="hour">
                            {{ hour.followupTime }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon class="suffix">schedule</mat-icon>
                </mat-form-field>
            </div>
            @if (!showFollowupReason) {
            <div [@balloonEffect]=currentState class="saved-status">
                <mat-icon class="material-icons">check_circle</mat-icon>
                <span>Saved</span>
            </div>
            } @else {
            <span class="saved-status"></span>
            }
        </div>
        <div class="followup-error-warn">
            @if (resourcesForm?.controls?.date?.invalid && resourcesForm?.controls?.date?.dirty) {
            <mat-error>This date is invalid</mat-error>
            }
        </div>
        @if (showFollowupReason) {
        <div class="saved-status-right">
            <div [@balloonEffect]=currentState class="saved-status">
                <mat-icon class="material-icons">check_circle</mat-icon>
                <span>Saved</span>
            </div>
        </div>
        }
        @if (showFollowupReason) {
        <div class="followup-reason">
            @if (showLabel) {
            <div class="follow-up-title">
                <span>&nbsp;</span>
            </div>
            }
            <mat-form-field class="app-form-field app-form-field-with-border" floatLabel="never">
                <input matInput #reason formControlName="followupReason" maxlength="50" (blur)="onReasonBlur()"
                    placeholder="Reason (optional)">
                <mat-hint align="end">{{ reason?.value?.length }} / 50</mat-hint>
                @if (hasError('followupReason', 'maxlength')) {
                <mat-error>Max 50 characters</mat-error>
                }
            </mat-form-field>
        </div>
        }
        @if (showFollowupReason) {
        <div class="followup-actions" style="padding:10px;">
            @if (showLabel) {
            <div class="follow-up-title">
                <span>&nbsp;</span>
            </div>
            }
            <div>
                <button mat-raised-button class="nova__button__secondary" [disabled]="isMarkedComplete()"
                    (click)="openMarkAsCompleteDialog()">
                    <span matTooltip="Add a follow-up date to complete" [matTooltipDisabled]="!isMarkedComplete()">
                        MARK AS COMPLETE
                    </span>
                </button>
            </div>
        </div>
        }
    </form>
    @if (showCalendar) {
    <div clickOutside (clickOutside)="clickOutside()" class="calendar-wrapper">
        <div class="row text-hint-calendar">
            Follow-Ups Scheduled
            <span class="chips-calendar low-data">0-20</span>
            <span class="chips-calendar med-data">21-40</span>
            <span class="chips-calendar high-data">41+</span>
        </div>
        <calendar (selectedDate)="updateDate($event)" [followupDates]="followupsByDay" [selectedDates]="selectedDates"
            (dateChanged)="selectedDateChanged($event)"></calendar>
    </div>
    }
</div>